import { z } from "zod";

export const additionalFieldSchema = z.object({
    label : z.string(),
    field_type : z.string(),
    required : z.boolean(),
    default_value : z.string(),
})